"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.814 12.36a1.281 1.281 0 0 1 2.225 0l-.607.349m-.505.526-1.318 2.298h2.636zm1.112-.874 1.516 2.643c.488.851-.117 1.93-1.113 1.93h-3.031c-.995 0-1.6-1.079-1.113-1.93l1.516-2.643M9.881 4.4a1.306 1.306 0 1 0 0 2.612 1.306 1.306 0 0 0 0-2.612M7.175 5.706a2.706 2.706 0 1 1 5.412 0 2.706 2.706 0 0 1-5.412 0m-3.902 7.776a1.7 1.7 0 0 1 1.7-1.7h1.819a1.7 1.7 0 0 1 1.7 1.7V15.3a1.7 1.7 0 0 1-1.7 1.7H4.973a1.7 1.7 0 0 1-1.7-1.7zm1.7-.3a.3.3 0 0 0-.3.3V15.3a.3.3 0 0 0 .3.3h1.819a.3.3 0 0 0 .3-.3v-1.818a.3.3 0 0 0-.3-.3z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.18 9.338h-1.8a2.2 2.2 0 0 0-2.2 2.2v1.115h1.4v-1.115a.8.8 0 0 1 .8-.8h5.023a.8.8 0 0 1 .8.8v1.115h1.4v-1.115a2.2 2.2 0 0 0-2.2-2.2h-1.822V7.792h-1.4z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=PlanManagerIcon20.js.map